'use client';

import {colors} from '@purpose/ui/styles/theme/colors';
import {OrganisationsCarousel} from '@purpose/ui/components/OrganisationsCarousel';
import {TFunction} from '@purpose/ui/utils/helpers';

interface OrganisationsCarouselWrapperCard {
  logo: string;
  name?: string;
  description?: string;
  subtitle?: string;
  id: number;
  organisation_name?: string;
  isRequestSent?: boolean;
}

interface OrganisationsCarouselWrapperProps {
  title?: string;
  onCardClick?: (id: number, orgId?: number) => void;
  cards?: OrganisationsCarouselWrapperCard[];
  onTitleClick?: () => void;
  buttonIconColor?: string;
  titleColor?: string;
  getDescription?: (
    card: OrganisationsCarouselWrapperCard
  ) => string | undefined;
  roundCards?: boolean;
  categoryDesign?: boolean;
  t: TFunction;
  addOrganisation?: () => void;
  withPlaceholderCards?: boolean;
  withGeneralPlaceholderCards?: boolean;
  overtitle?: (b: any) => React.JSX.Element;
  renderLastCard?: () => React.ReactNode;
}

const OrganisationsCarouselWrapper = ({
  title,
  cards,
  onTitleClick,
  onCardClick,
  titleColor = colors.black,
  buttonIconColor = colors.primary.base,
  getDescription,
  roundCards = false,
  categoryDesign = false,
  t,
  addOrganisation,
  withPlaceholderCards,
  withGeneralPlaceholderCards,
  overtitle,
  renderLastCard
}: OrganisationsCarouselWrapperProps) => {
  if (!cards?.length) return null;

  return (
    <OrganisationsCarousel
      title={title}
      cards={cards}
      onTitleClick={onTitleClick}
      onCardClick={onCardClick}
      renderLastCard={renderLastCard}
      titleColor={titleColor}
      buttonIconColor={buttonIconColor}
      getDescription={getDescription}
      roundCards={roundCards}
      categoryDesign={categoryDesign}
      t={t}
      addOrganisation={addOrganisation}
      withPlaceholderCards={withPlaceholderCards}
      withGeneralPlaceholderCards={withGeneralPlaceholderCards}
      overtitle={overtitle}
    />
  );
};

export {OrganisationsCarouselWrapper};
export type {
  OrganisationsCarouselWrapperProps,
  OrganisationsCarouselWrapperCard
};
